(() => {
  let timer;
  const curtainEl = document.querySelector('.js-curtain');
  if (curtainEl) {
    window.addEventListener('load', () => {
      curtainEl.classList.remove('show');
      curtainEl.classList.add('hide');
      if (timer) {
        clearTimeout(timer);
      }
      // Dispatch curtain event
      const event = new Event('curtain');
      window.dispatchEvent(event);
    });
  }
})();
